export const validatePasswordLength = (value: string): string | true => {
  if (value.length < 8) {
    return "Password should be more than 8 characters";
  } else if (value.length > 30) {
    return "Password should be less than 30 characters";
  }
  return true;
};
